exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nl2br[data-v-f7f5bd4c] {\n  white-space: pre-line;\n  line-height: 1.2;\n}\n.modal-footer[data-v-f7f5bd4c] {\n  display: flex;\n  justify-content: center;\n  padding: 10px;\n}\n.modal-button[data-v-f7f5bd4c] {\n  float: right;\n  white-space: initial;\n  padding: 10px 20px;\n  border-radius: 5px;\n  color: #978564;\n  background: transparent;\n  border: 1px solid #978564;\n  transition: background-color 0.3s ease;\n}\n.modal-button[data-v-f7f5bd4c]:hover {\n  background: #b1a781;\n  border: 1px solid #b1a781;\n  color: #fff;\n}\n", ""]);

// exports
